module.exports = __webpack_public_path__ + "img/fleurs_de_riz.921202de.jpg";